import DefaultCover from 'assets/images/digital/default-cover.jpg'

export default function coverImageUrl(options, images, defaultImage = DefaultCover){
  if (options && options.cover_image_id){
    const image = images[options.cover_image_id]
    if (image && image.large_url){
      return image.large_url
    }
  }

  return defaultImage
}
